import _ from "@lodash";
import { AppBar, Dialog, DialogActions, DialogContent, Toolbar, Typography } from "@material-ui/core";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import MobileDetect from "mobile-detect";
import React from "react";
import { MdWarning } from "react-icons/md";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import XAPPButton from "../Button/XAPPButton";
import * as Actions from "./Store/Actions/ConfirmacaoActions";

const md = new MobileDetect(window.navigator.userAgent);

class ConfirmacaoDialog extends XAPPComponent {

    closeComposeDialog = (event) => {
        this.props.closeDialog();
        if (this.props.onConfirmation !== undefined && this.props.onConfirmation !== null) {
            this.props.onConfirmation(event, this.props.data);
        }
    };

    render() {
        const { Confirmacao, mensagem, id, tipoAcao } = this.props;
        return (
            <Dialog
                {...Confirmacao}
                open={!_.isNull(Confirmacao.id) && Confirmacao.id === id ? true : false}
                fullWidth
                maxWidth="xs"
                onClick={ev => ev.stopPropagation()}
            >
                <AppBar position="static" elevation={1}>
                    <Toolbar className="flex w-full min-h-48">
                        <MdWarning className="mr-8 text-32 text-orange-light" />
                        <Typography variant="subtitle1 text-white">
                            {tipoAcao === "alerta" ? "Alerta" : "Confirmação"}
                        </Typography>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <div className="flex pt-8">
                        <Typography
                            className="h3"
                            color="textPrimary"
                        >
                            {mensagem}
                        </Typography>
                    </div>
                </DialogContent>
                <AppBar position="static" elevation={3} color="textSecondary">
                    <Toolbar className="flex w-full justify-end min-h-0">
                        <DialogActions>
                            {tipoAcao === "alerta" ?
                                <XAPPButton
                                    type="Button"
                                    className="bg-green hover:bg-green text-white"
                                    onClick={(ev) => {
                                        ev.stopPropagation();
                                        this.props.closeDialog();
                                    }}
                                    variant="contained"
                                    iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                    icon={null}
                                    label={"Ok"}
                                    key={id + "_Ok"}
                                />
                                :
                                <React.Fragment>
                                    <XAPPButton
                                        type="Button"
                                        className="bg-green hover:bg-green text-white mr-8"
                                        onClick={(ev) => {
                                            this.closeComposeDialog(ev);
                                        }}
                                        variant="contained"
                                        iconProps={"mr-8"}
                                        icon={"done"}
                                        label={"Sim"}
                                        key={id + "_Sim"}
                                    />
                                    <XAPPButton
                                        type="Button"
                                        className="bg-red hover:bg-red text-white"
                                        onClick={(ev) => {
                                            ev.stopPropagation();
                                            this.props.closeDialog();
                                        }}
                                        variant="contained"
                                        iconProps={"mr-8"}
                                        icon={"close"}
                                        label={"Não"}
                                        key={id + "_Nao"}
                                    />
                                </React.Fragment>
                            }
                        </DialogActions>
                    </Toolbar>
                </AppBar>
            </Dialog>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        closeDialog: Actions.closeDialog,
    }, dispatch);
}

function mapStateToProps({ ConfirmacaoApp }) {
    return {
        Confirmacao: ConfirmacaoApp,
    };
}


export default connect(mapStateToProps, mapDispatchToProps)(ConfirmacaoDialog);


